import React from 'react';
import PropTypes from 'prop-types';
import CurrencyContainer from './../containers/CurrencyContainer';

const Summary = ({total, selectedDoctype, selectedLevel, currencySymbol, selectedVasIds, vases, selectedVasItems, discountPercent, discountValue = 0}) => (
    <div className="price-wrp-top">
        <div className="currency-wrp">
            <div className="currency-txt">Summary</div>
            <CurrencyContainer />
        </div>
        <ul className="summary-list">
            <li className="summary-list-item">
                {selectedDoctype.name} <span className="exp-lvl-txt">- {selectedLevel.name} level</span>
            </li>
        </ul>
        <ul className="summary-list summary-list__2">
            {Object.keys(selectedVasIds).map(i => (
                <li key={selectedVasIds[i]} className="summary-list-item">
                    {vases[selectedVasIds[i]].name}
                    {selectedVasItems[selectedVasIds[i]] &&
                        ': ' + selectedVasItems[selectedVasIds[i]]
                    }
                </li>
            ))}
        </ul>
        {discountValue > 0 &&
            <div className="totWrap__full">
                <div id="summery-discount-text" className="totWrap__full-price-left">
                    Your <span className="totWrap__full-discount"></span>{discountPercent}% discount:
                </div>
                <span id="summery-discount-cost" className="totWrap__full-price-right">
                     <span className="totWrap__full-price">-{currencySymbol}{discountValue}</span>
                </span>
            </div>
        }
        <div className="totWrap-bot">
            <div className="tot">Total: </div>
            <span id="total"> {currencySymbol}{(total - discountValue).toFixed(2)}</span>
        </div>
    </div>
);

Summary.propTypes = {
    total: PropTypes.number.isRequired,
    selectedDoctype: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    selectedLevel: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    currencySymbol: PropTypes.string.isRequired,
    selectedVasIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    vases: PropTypes.object.isRequired,
    selectedVasItems: PropTypes.object.isRequired,
    discountValue: PropTypes.number,
    discountPercent: PropTypes.number,
};

export default Summary